import { useWindowSize } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import { isDisplayTradingVolumePoint } from 'modules/asset/AssetPage/assetPageUtils'
import styles from './CustomizedXAxisTick.module.scss'

const CustomizedXAxisTick = props => {
  const {
    x,
    y,
    payload: { value, index },
    rangeDataLabels,
    chartTimeline
  } = props

  const { screenWidth } = useWindowSize()

  if (!rangeDataLabels[index]) return null

  const { key, unique, last, pair, eachThird, eachFifth } = rangeDataLabels[index]

  if (isDisplayTradingVolumePoint(index, key, unique, last, pair, eachThird, eachFifth, screenWidth, chartTimeline)) {
    return (
      <g transform={`translate(${x},${y})`} className={styles.CustomizedXAxisTick}>
        <text dy={10} dx={last ? 10 : 20} fill="#B9BABE" textAnchor="end" className={styles.Small}>
          {value}
        </text>
      </g>
    )
  }
  return null
}

CustomizedXAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.shape({
    value: PropTypes.string,
    index: PropTypes.number
  }),
  rangeDataLabels: PropTypes.arrayOf(
    PropTypes.shape({
      day: PropTypes.string,
      key: PropTypes.number,
      unique: PropTypes.bool,
      last: PropTypes.bool,
      pair: PropTypes.bool,
      eachThird: PropTypes.bool,
      eachFifth: PropTypes.bool
    })
  ),
  chartTimeline: PropTypes.string
}

CustomizedXAxisTick.defaultProps = {
  x: 0,
  y: 0,
  payload: { value: '' },
  rangeDataLabels: [],
  chartTimeline: ''
}

export default CustomizedXAxisTick
